export enum JobOwnerTypeText {
    Contractors = 0,
    Farmers = 1,
}